---
fr:
  om_dashboard:
    active_alarm: Alarme active
    alarm:
      alarm: Alarme
      alarm_category: Catégorie d'alarme
      alarms_as_of: "{num} alarmes {critical} actives du {when}"
      all_active_alarms: Tout les alarmes actives
      command: Commande
      critical: critiques
      critical_active_alarms: Alarmes critiques actives
      critical_high_alarm: Alarme haute critique
      critical_low_alarm: Alarme basse critique
      duration: Durée
      end: Fin
      energy_losses: Pertes [MWh]
      high_alarm: Alarme haute
      hydro_component_name: Turbine
      inverter_name: Onduleur
      last_update: Dernière mise à jour
      low_alarm: Alarme basse
      mppt_name: MPPT
      ok: OK
      operational_status: Statut opérationnel
      recent_alarms_and_events: Alarmes et événements récents
      sensor_name: Nom du capteur
      sensor_type: Type de capteur
      setpoint: Valeur cible
      solar_component_name: Onduleur
      start: Début
      status: Statut
      warning: Avertissement
      wind_component_name: Turbine
    alarm_status:
      environmental: Conditions environnementales
      force_majeure: Force majeure
      grid_failure: Perturbation réseau
      inverter_outage: Défaillance onduleur
      manufacturer: Alarme du fabricant
      mppt_outage: Défaillance MPPT
      no_data: Données manquantes
      normal_operation: Fonctionnement normal
      owner: Arrêté par le propriétaire
      power_limitation: Limitation de puissance
      snow_coverage: Couverture neigeuse
      still_active: En cours
      stopped_by_owner: Arrêté par le propriétaire
      string_anomaly: Anomalie String
      turbine_ok: Éolienne OK
    alarms: Alarmes
    alarms_lowcase: alarmes
    component_status: Statut des composants
    drilldown:
      accumulated_hours: Heures accumulées des alarmes
      accumulated_hours_of_operational_statuses: Heures cumulées des statuts opérationnels
      active_power: Effet actif
      alarm_codes: Codes d'alarme
      alarm_filter: Filtrer par capteur / mot-clé
      alarm_frequency_disclaimer: Heures dont l'irradiance dépasse le seuil d'irradiance minimal défini (60 W/m² par défaut)
      all_mppts: Tous les MPPTs
      annual_limit: Limite annuelle
      any: Tout
      availability_target: Objectif
      charts: Graphiques
      choose_field: Choix du champ
      choose_mppt: Choisissez MPPT...
      compare_another: Ajouter un onduleur
      compare_with: Comparaison avec
      compare_with_another: Ajouter un MPPT à comparer
      compare_with_inverter: Comparaison {inverter_name} avec
      compare_with_turbine: Comparaison {turbine_name} avec
      compared_power_curves: 'Comparaison des courbes de puissance:'
      contractual_availability: Disponibilité contractuelle
      critical_alarms: Entrées d'état d'alarme critique
      current: Courant
      current_env_flow: Exigence actuelle du débit d'eau minimum
      date_summer: Date d'été
      date_winter: Date d'hiver
      dc_current_unit: Courant DC [A],
      dc_current_unit_normalized: Courant DC [%],
      dc_power_unit: Puissance DC [kW],
      dc_power_unit_normalized: Puissance DC [%],
      dc_voltage_unit: Tension DC [V],
      dc_voltage_unit_normalized: Tension DC [%]
      downtime_hours: Durée des pannes
      end_date: Fin
      end_time: Heure de fin
      energy_based: Calcul de disponibilité basé sur l'énergie.
      energy_based_availability: Disponibilité basée sur l'énergie
      energy_losses: Pertes
      energy_performance_index: Energy Performance Index
      energy_produced: Énergie produite
      expected_operating_hours: Heures d'exploitation attendues
      export_menu:
        download_csv: Télécharger le CSV
        download_jpg: Télécharger l'image JPEG
        download_pdf: Télécharger le document PDF
        download_png: Télécharger l'image PNG
        download_svg: Télécharger l'image vectorielle SVG
        download_xls: Télécharger le XLS
        filenames:
          contractual_availability: disponibilité_contractuelle
          energy_performance: performance
          energy_production: production
          mppt_heatmap: mppt_heatmap
          mppt_production: mppt_production
          power_curve: courbe_de_puissance
          production_chart: production
        print_chart: Imprimer le graphique
        tooltip: Télécharger les données
        view_data_table: Voir le tableau de données
        view_full_screen: Afficher en plein écran
      external_theoretical: Modèle météo
      fall_loss: Perte de chute
      fall_loss_intake: Perte de chute à l'entrée
      fall_loss_penstock: Perte de chute de la conduite forcée
      filter: Filtre
      frequency: Fréquence
      full_load_hours: Heures à pleine charge
      gen_l1l2: Gén L1L2
      gen_l2l3: Gén L2L3
      gen_l3l1: Gén L3L1
      group_by_category: Groupe par catégorie
      hours: Heures
      hours_without_alarms: Heures sans alarmed
      inverter: Onduleurs
      inverter_production_stats: "{amount} MW le {timeframe}"
      inverter_single: 'Onduleur: {name}'
      key_performance: Indicateurs
      key_performance_for: Indicateurs pour {name}
      last_outage: Dernière panne détectée le {date}
      last_week: 7 derniers jours
      level_downstream: Niveau en aval
      level_upstream: Niveau en amont
      measured: Mesurée
      most_frequent_alarms: Alarmes les plus fréquentes
      most_frequent_alarms_subtitle: Total {number} heures accumulées des alarmes durant {time_period}
      mppt: MPPT
      mppt_single: 'MPPT: {name}'
      no_new_outages: Aucune novuelle panne
      no_weather_data: Aucune donnée météorologique trouvée
      normalized_power: Puissance normalisée [%]
      normalized_values: Valeurs normalisées
      operation: En fonctionnement
      operational_status: Statut opérationnel
      operational_status_of_inverter: Statut opérationnel pour {name}
      operational_status_of_mppt: Statut opérationnel pour {name}
      operational_status_of_mppts: Chronologies des MPPT
      operational_status_per_turbine: Statut opérationnel par turbine
      p50_target: P50
      penstock_pressure: Pression de la conduite forcée
      performance: Performance
      performance_ratio: Performance Ratio
      performance_subtitle: Performance ratio de {amount}% pour {timeframe}
      potential: Potentiel
      potential_loss: Perte potentielle
      power: Puissance
      power_current_or_voltage: Courant, puissance ou tension
      power_curve: Courbe de puissance
      power_curve_for: Courbe de puissance pour {name}
      power_curve_inv_x_title: Puissance théorique
      power_curve_mppt_x_title: Puissance de référence
      power_curve_subtitle: 'Pertes d''énergie : {losses} MWh'
      power_curve_unit_solar: kW
      power_curve_unit_wind: MW
      power_curve_x_title: Puissance théorique
      power_curve_y_title: Puissance mesurée
      power_loss: Pertes de puissance
      power_y_title: Puissance [{unit}]
      production: Production
      production_for_inverter: Production pour {name}
      production_in_mw: Production en MW
      production_per_mppt: Production par MPPT pour {name}
      production_status_per_inverter: Statut de production par onduleur
      reactive_power: Effet réactif
      regulation: Régulation
      remove_comparison: Supprimer la comparaison
      set_point: Point de consigne
      set_point_autostart: Point de consigne de l'autostart
      set_point_water_level: Point de consigne du niveau d'eau
      shadow_testing_banner: Le shadow testing est actif pour cette centrale — les plans de production sont calculés mais ne sont pas envoyés à Kaia Trade.
      show_abnormal: Afficher uniquement les anomalies
      show_all: Tout afficher
      show_only_time_with_active_alarms: Afficher uniquement les périodes avec alarmes
      specific_mppts: MPPT(s) spécifiques
      start_date: Début
      start_time: Heure de début
      start_time_must_be_before_end_time: L'heure de début doit être avant l'heure de fin
      start_up_mode: Mode de démarrage
      supervision_power: Effet de supervision
      temp_outside: Température extérieure
      theoretical: Théorique
      time_ago: Il y a {duration}
      time_based: Calcul de disponibilité basé sur le temps.
      time_based_availability: Disponibilité basée sur le temps
      time_scope:
        3m: 3 mois
        month: Mois
        quarter: Trimestre
        week: Semaine
        year: Année
      time_with_active_alarms: Total avec alarmes
      tooltip_hidden: Légende désactivée en raison de la quantité élevée de données
      total_availability: Disponibilité totale basée sur l'énergie
      triggered_at: Déclenché à
      turbine: Turbine
      turbine_alarm_loss: "{mw_loss} MWh perdu de {time_period}"
      turbine_power_curve_x_title: Vitesse du vent
      turbine_power_curve_x_unit: m/s
      turbine_power_curve_y_title: Puissance
      turbine_power_curve_y_unit: MW
      turbine_single: 'Turbine: {name}'
      turbine_timeline: Chronologie des alarmes
      types_of_alarms: Types d'alarmes
      unavailable: Indisponible
      voltage: Tension
      water_flow: Débit d'eau
      water_level: Niveau d'eau
      water_level_downstream: Niveau d'eau en aval
      weather: Météo
      weather_data: Données météorologiques
      weather_forecast: Prévisions météorologiques
      weather_model: Modèle météo
      wind_production_for: Production en MW pour les turbines
      wind_rose: Rose des vents
      wind_rose_missing: Les données de direction du vent sont seulement disponibles pour la semaine dernière. Contactez le support Portal support pour plus d'informations.
      wind_rose_text: Vitesse et direction du vent pour la période sélectionnée
    duration:
      plural:
        day: "{value} jours"
        hour: "{value} heures"
        minute: "{value} minutes"
      short:
        day: "{value}j"
        hour: "{value}h"
        minute: "{value}m"
      singular:
        day: "{value} jour"
        hour: "{value} heure"
        minute: "{value} minute"
    env_flow: Débit environnemental
    filter: Filtrer la liste
    help:
      alarm_inactive: Alarme active au cours des {age} dernières, mais maintenant inactive
      alarm_triggered: Alarme déclenchée pendant les {age} derniers
      env_flow_threshold: Configuration du seuil de débit environnemental manquante (formulaire de centrale électrique)
      no_alarm: Aucune alarme pendant les {age} derniers
      no_live_data: Aucune donnée en direct pendant les {age} derniers
      sensor_type: Type de capteur "{sensor_type}" manquant
      upper_alert_limit: Limite d'alerte supérieure du capteur non définie
    hydro:
      reservoir_status:
        avg_inflow: Débit entrant moyen (24h)
        avg_inflow_tooltip: Débit d'eau entrant attendu en moyenne sur les prochaines 24 heures
        below_operational_min: Sous le minimum opérationnel
        days: "{days} jours"
        days_and_hours: "{days} jours, {hours} heures"
        days_and_hours_label: "{days} jours, {hours} heures"
        days_label: jours
        hours: "{hours} heures"
        hours_label: heures
        no_data: Aucune donnée d'état du réservoir disponible
        no_inflow: Aucun débit entrant
        of: de
        operational_energy: Énergie opérationnelle
        operational_energy_tooltip: 'Énergie utilisable dans les limites opérationnelles, basée sur le niveau d''eau.<br>Plage opérationnelle: {operational_capacity} MWh, entre {op_min_energy} MWh (min opérationnel) et {op_max_energy} MWh (max opérationnel).<br>Énergie totale stockée: {absolute_volume} MWh sur {full_capacity} MWh théoriques. Hors plage opérationnelle: {spare_capacity} MWh.'
        production_time: Temps de production complète
        production_time_tooltip: Durée pendant laquelle la centrale peut fonctionner à pleine capacité ({power} MW) avec le volume actuel du réservoir et sans nouvel apport d'eau
        reservoir_full: Réservoir plein
        time_to_fill: Temps de remplissage
        time_to_fill_tooltip: Temps pour remplir le réservoir basé sur la plage opérationnelle du modèle et le débit entrant moyen (24h) sans production. Peut ne pas atteindre la capacité théorique complète si fonctionnement dans une plage limitée.
        title: État actuel du réservoir
    nest_comm_down: Communication Nest interrompue
    operations: Exploitation
    overflow: Débordement
    overview:
      asset: Installation
      capacity: Puissance nominale
      components: Composants
      forecast: Prévision
      forecast_48h: Prévision dans 48h
      forecast_now: Météo actuelle
      in_48h: Dans 48h
      last_update: Mise à jour
      load: Puissance
      loss: Pertes
      losses: Pertes
      lost_revenue: Pertes {currency_code}/h
      name: Nom
      only_revenue: Revenu
      production: Production
      production_stop: Arrêt de production
      revenue: Revenu {currency_code}/h
      status: Status
      title: Aperçu O&M
    power_plant: Installation
    power_plant_short: Installation
    power_plant_type:
      magazine: Centrale à accumulateur
      run_of_river: Centrale au fil de l'eau
      solar: Parc solaire
      wind: Parc éolien
    prod_status:
      outage: Panne
      producing: En production
      ready: Prêt à démarrer
    sensor_mapping:
      clear_search: Effacer la recherche
      discard_confirm: Vous avez des modifications non enregistrées. Les abandonner ?
      filter_all: Tous
      filter_mapped: Associés
      filter_unmapped: Non associés
      launcher: Configuration des capteurs
      load_error: Impossible de charger les capteurs.
      loading: Chargement des capteurs Nest…
      mapped_heading: Associés ({count})
      no_available_types: Aucun type de capteur disponible
      no_matches: Aucun capteur ne correspond à votre recherche.
      save_all: Tout enregistrer
      search: Rechercher par nom
      unmapped: Non associé
      unmapped_heading: Non associés ({count})
      unsaved_changes: Modifications non enregistrées
    sensor_types:
      chart: Graphique
      sidebar: Barre latérale
    show_instant_triggers: Afficher les déclencheurs instantanés
    status:
      hydro:
        low_natural_resource: Ressource naturelle faible
        missing_natural_resource: Ressource naturelle manquante
        missing_resource: Ressource naturelle manquante
        missing_status: Statut manquant
        no_change: Aucun changement
        no_data: Données manquantes
        no_energy: Puissance nulle
        normal: Normal
        normal_operation: Fonctionnement normal
        one_year_ago: il y a un an
        outage: Défaillance
        recent_issue_solved: Problème récent résolu
        underperforming: Sous-performance
      neutral:
        low_natural_resource: Ressource naturelle faible
        missing_natural_resource: Hors conditions opérationnelles
        missing_resource: Hors conditions opérationnelles
        missing_status: Statut manquant
        no_change: Aucun changement
        no_data: Données manquantes
        no_energy: Puissance nulle
        normal: Normal
        normal_operation: Fonctionnement normal
        one_year_ago: il y a un an
        outage: Défaillance
        recent_issue_solved: Problème récent résolu
        underperforming: Sous-performance
      solar:
        low_natural_resource: Faible ensoleillement
        missing_natural_resource: Nuit
        missing_resource: Nuit
        missing_status: Statut manquant
        no_change: Aucun changement
        no_data: Données manquantes
        no_energy: Puissance nulle
        normal: Normal
        normal_operation: Fonctionnement normal
        one_year_ago: il y a un an
        outage: Défaillance
        recent_issue_solved: Problème récent résolu
        resource_above_threshold: Ressource au-dessus du seuil
        resource_below_threshold: Ressource en dessous du seuil
        underperforming: Sous-performance
      wind:
        low_natural_resource: Vent faible
        missing_natural_resource: Hors conditions opérationnelles
        missing_resource: Hors conditions opérationnelles
        missing_status: Statut manquant
        no_change: Aucun changement
        no_data: Données manquantes
        no_energy: Puissance nulle
        normal: Normal
        normal_operation: Fonctionnement normal
        one_year_ago: il y a un an
        outage: Défaillance
        recent_issue_solved: Problème récent résolu
        underperforming: Sous-performance
    technical: Technique
